
// 正しいメールアドレスならtrueを返す
export function validateEmail(email) {
  const mailRegex = /^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
  return mailRegex.test(email)
}